import React, { useState, useEffect } from 'react';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { Box, Container, Typography, CircularProgress } from '@mui/material';
import { Dashboard } from './components/Dashboard';
import { authService } from './services/authService';

const theme = createTheme({
  palette: {
    primary: {
      main: '#2196f3',
    },
    secondary: {
      main: '#9c27b0',
    },
    background: {
      default: '#f5f5f5',
    },
  },
  typography: {
    fontFamily: '"Lato", sans-serif',
  },
});

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState<boolean | null>(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const validateSSID = async () => {
      try {
        setIsLoading(true);
        const isValid = await authService.validateAndAuthenticate();
        setIsAuthenticated(isValid);
      } catch (error) {
        console.error('Authentication error:', error);
        setIsAuthenticated(false);
      } finally {
        setIsLoading(false);
      }
    };

    validateSSID();
  }, []);

  if (isLoading) {
    return (
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100vh',
            bgcolor: '#ffffff',
          }}
        >
          <CircularProgress />
        </Box>
      </ThemeProvider>
    );
  }

  if (!isAuthenticated) {
    const ssid = authService.extractSSIDFromURL();
    const errorMessage = ssid 
      ? 'Invalid SSID: Authentication failed'
      : 'Invalid SSID: No SSID parameter found in URL';

    return (
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100vh',
            bgcolor: '#ffffff',
          }}
        >
          <Container maxWidth="sm">
            <Box
              sx={{
                bgcolor: '#282c34',
                border: '2px solid #e06c75',
                borderRadius: '8px',
                p: 4,
                textAlign: 'center',
                maxWidth: '500px',
                mx: 'auto',
              }}
            >
              <Box
                sx={{
                  width: 64,
                  height: 64,
                  borderRadius: '50%',
                  bgcolor: '#e06c75',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  mx: 'auto',
                  mb: 3,
                }}
              >
                <Typography
                  sx={{
                    color: '#ffffff',
                    fontSize: '36px',
                    fontWeight: 'bold',
                    lineHeight: 1,
                  }}
                >
                  !
                </Typography>
              </Box>
              <Typography
                variant="h5"
                sx={{
                  color: '#ffffff',
                  fontWeight: 'bold',
                  mb: 2,
                }}
              >
                Authentication Failed
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  color: '#ffffff',
                }}
              >
                {errorMessage}
              </Typography>
            </Box>
          </Container>
        </Box>
      </ThemeProvider>
    );
  }

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Dashboard />
    </ThemeProvider>
  );
}

export default App;

